import { createSelector } from "reselect";
import { State } from "../../../redux/state";

export const jumpsellerRoot = (state: State) => state.jumpseller;

export const settingSelector = createSelector(
  jumpsellerRoot,
  (jumpseller) => jumpseller.settings
);
